import React, { useState, useRef, useEffect } from 'react';

const ActionDropdown = ({ actions = [], label = 'Actions', className = '' }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div className={`relative inline-block ${className}`} ref={ref}>
      <button
        onClick={() => setOpen((o) => !o)}
        className="btn-outline px-3 py-1 text-xs"
      >
        {label}
      </button>
      {open && (
        <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded shadow z-10">
          {actions.map((a) => (
            <button
              key={a.label}
              onClick={() => {
                setOpen(false);
                a.onClick();
              }}
              className={`block w-full text-left px-3 py-2 hover:bg-gray-50 text-sm ${a.className || ''}`}
            >
              {a.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ActionDropdown;
